// Generated from legacy db.ts to keep files under 500 lines.
import { sql } from "../../base";
import type { UserHiddenTemplate } from "../../types";

const userHiddenTemplatesModule = {
  async findByUserId(userId: string): Promise<UserHiddenTemplate[]> {
    try {
      const result = await sql`
        SELECT * FROM user_hidden_templates
        WHERE user_id = ${userId}
      `;
      return (result || []) as UserHiddenTemplate[];
    } catch (error) {
      console.error('Error fetching hidden templates:', error);
      return [];
    }
  },
  
  async hide(userId: string, goalTemplateId: string): Promise<UserHiddenTemplate> {
    const result = await sql`
      INSERT INTO user_hidden_templates (user_id, goal_template_id)
      VALUES (${userId}, ${goalTemplateId})
      ON CONFLICT (user_id, goal_template_id) DO NOTHING
      RETURNING *
    `;
    return result[0] as UserHiddenTemplate;
  },
  
  async unhide(userId: string, goalTemplateId: string): Promise<boolean> {
    const result = await sql`
      DELETE FROM user_hidden_templates
      WHERE user_id = ${userId} AND goal_template_id = ${goalTemplateId}
    `;
    return result.count > 0;
  }
};

export type UserHiddenTemplatesModule = typeof userHiddenTemplatesModule;

export function registerUserHiddenTemplates(db: { userHiddenTemplates?: UserHiddenTemplatesModule }) {
  db.userHiddenTemplates = userHiddenTemplatesModule;
}

export { userHiddenTemplatesModule as userHiddenTemplates };
